<template>
    <div>
        <h3 class="mb-3">Number of messages per channel</h3>
        <div class="no-data-placeholder" v-if="!this.channels.length">
            <img class="w-h-35 vertical-align-middle" src="../../assets/img/box.svg">
            <span class="vertical-align-middle mx-2 italic">
                No available results for this time period
            </span>
        </div>
        <apex-chart type="bar" :options="options" :series="series"></apex-chart>
    </div>
</template>

<script>
    import apexChart from "vue-apexcharts";
    export default {
        name: "messages-per-session",
        components: {
            apexChart
        },
        props: {
            channels: {
                type: Array,
                default: ()=> {
                    return []
                }
            }
        },
        data () {
            return {
                options: {
                    chart: {
                        id: 'avg-msg-per-session'
                    },
                    xaxis: {
                        categories: []
                    },
                    yaxis: {
                        title: {
                            text: 'Message / Session'
                        }
                    }
                },
                series: [

                ]
            }
        },
        watch: {
            channels () {

                this.series[0] = {
                    name: 'Bot',
                    data: []
                }

                this.series[1] = {
                    name: 'User',
                    data: []
                }

                let categories = []
                for (let i=0; i<this.channels.length; i++) {
                    this.series[0].data.push(this.channels[i].data.total_bot_msgs)
                    this.series[1].data.push(this.channels[i].data.total_user_msgs)
                    categories.push(this.channels[i].name)
                }

                this.options = {
                    chart: {
                        type: 'bar',
                        height: 350,
                        stacked: true,
                        toolbar: {
                            show: true
                        },
                        zoom: {
                            enabled: true
                        }
                    },
                    xaxis: {
                        categories: categories
                    },
                    yaxis: {
                        title: {
                            text: 'Number of messages'
                        }
                    }
                }

            }
        }
    }
</script>

<style scoped>

</style>